<template>
  <div class="page-container">
    <header>
      <img class="header-img" src="../assets/0.png">
    </header>
    <main>
      <section>
        <div class="title-container">
          <div class="title-tag"></div>
          <div class="title">{{ $t("title1") }}</div>
        </div>
        <article>{{ $t("article1") }}</article>
      </section>
      <section>
        <div class="title-container">
          <div class="title-tag"></div>
          <div class="title">{{ $t("title2") }}</div>
        </div>
        <article>{{ $t("article2") }}</article>
      </section>
      <section>
        <div class="title-container">
          <div class="title-tag"></div>
          <div class="title">{{ $t("title3") }}</div>
        </div>
        <div class="hot-essay-container">
          <a 
            v-for="(item,index) in $t('list1')" 
            :href="item.url" 
            :key="`hot-tutorial-${index}}`"
            target="_blank" 
          >
            <div class="hot-essay-item">
              <div class="hot-essay-item-img-container">
                <img :src="item.pic" />
              </div>
              <div class="hot-essay-item-content">
                <p>{{ item.title }}</p>
                <p>{{ item.subtitle }}</p>
              </div>
            </div>
          </a>
        </div>
      </section>
      <section>
        <div class="title-container">
          <div class="title-tag"></div>
          <div class="title">{{ $t("title4") }}</div>
        </div>
        <div class="hot-essay-container">
          <a 
            v-for="(item,index) in $t('list2')" 
            :href="item.url" 
            :key="`hot-tutorial-${index}}`"
            target="_blank" 
          >
            <div class="hot-essay-item">
              <div class="hot-essay-item-img-container">
                <img :src="item.pic" />
              </div>
              <div class="hot-essay-item-content">
                <p>{{ item.title }}</p>
                <p>{{ item.subtitle }}</p>
              </div>
            </div>
          </a>
        </div>
      </section>

      <section>
        <div class="title-container">
          <div class="title-tag"></div>
          <div class="title">{{ $t("title5") }}</div>
        </div>
        <div class="hot-essay-container">
          <a 
            v-for="(item,index) in $t('list3')" 
            :href="item.url" 
            :key="`hot-tutorial-${index}}`"
            target="_blank" 
          >
            <div class="hot-essay-item">
              <div class="hot-essay-item-img-container">
                <img :src="item.pic" />
              </div>
              <div class="hot-essay-item-content">
                <p>{{ item.title }}</p>
                <p>{{ item.subtitle }}</p>
              </div>
            </div>
          </a>
        </div>
      </section>
      <section>
        <div class="title-container">
          <div class="title-tag"></div>
          <div class="title">{{ $t("title5") }}</div>
        </div>
        <div class="more-info-container1">
          <a 
            v-for="(item, index) in $t('moreList')" 
            target="_blank" 
            :key="`more-info-${index}}`" 
            :href="item.url"
          >
            {{ item.title }}
          </a>
        </div>
      </section>
      <section>
        <div class="warning">
          <div class="warning-tag">
            <p>*</p>
          </div>
          <div class="warning-content">
            <p>{{ $t("warning") }}</p>
          </div>
        </div>
        <div class="share-container">
          <div class="share center" @click="copy">
            <!-- <img src="../assets/share.png"> -->
            <span :class="{'fixed-span':$i18n.locale !== 'zh'}">{{ $t("share") }}</span>
          </div>
        </div>
      </section>
    </main>
    <div class="toast" v-if="show">{{ $t('copied') }}</div>
  </div>
</template>

<script>
import copyToClipboard from 'copy-to-clipboard';
export default {
  name: 'HelloWorld',
  data() {
    return {
      show: false
    }
  },
  methods: {
    copy() {
      this.show = true
      setTimeout(() => {
        this.show = false
      }, 2000)
      copyToClipboard(location.href);
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.page-container {
  .header-img {
    width: 100%;
  }
  section {
    margin-top: 25px;
    overflow: hidden;

    .title-container {
      height: 25px;

      .title-tag {
        height: 25px;
        width: 7px;
        background-color: #2980fe;
        margin-left: 25px;
        float: left;
      }

      .title {
        height: 25px;
        line-height: 25px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
        font-size: 22px;
        float: left;
        margin-left: 5px;
      }

      .title-tip {
        float: left;
        text-align: center;
        height: 25px;
        padding: 3.5px 5px;
        font-size: 12px;
        background: #F5F9FF;
        border-radius: 4px;
        border: 1px solid #F5F9FF;
        margin-left: 5px;
        transform: scale(0.8);
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #2980fe;
      }
    }

    article {
      font-size: 13.5px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #515151;
      letter-spacing: 1px;
      padding-left: 30px;
      padding-right: 20px;
      margin-top: 10px;
      line-height: 21px;
    }

    .hot-essay-container{
        margin-left: 35px;
        margin-top: 10px;
        .hot-essay-item{
          height: 110px;
          line-height: 110px;
          border-bottom: #F5F5F5 1px solid;
          .hot-essay-item-img-container{
            float: left;
            margin-top: 20px;
            height: 70px;
            box-shadow: 0px 1px 15px 0px rgba(0, 0, 0, 0.2);
            border-radius: 8px;
            border: 1px solid #FFFFFF;
            overflow: hidden;
            img{
              height: 70px;
            }
            img:first-child{
              width: 93.33px;
            }
          }
          .hot-essay-item-tag-container{
            float: right;
            width: 30px;
            height: 100%;
            img{
              width: 13px;
              height: 13px;
              margin-left: 5px;
            }
          }
          .hot-essay-item-content{
            margin-right: 30px;
            margin-left: 110px;
            height: 110px;
            padding-top: 15px;
            font-family: PingFangSC-Regular, PingFang SC;
            display: flex;
            flex-direction: column;

            p:first-child{
              font-size: 13px;
              line-height: 20px;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              text-overflow: ellipsis;
              overflow: hidden;
              display: -webkit-inline-box;
              font-weight: 400;
              color: #515151;
            }
            p:last-child{
              font-weight: 400;
              color: #AAAAAA;
              font-size: 12px;
              margin-bottom: 14px;
              color: #9ea0a5;
              line-height: 14px;
              margin-top: 5px;
            }
          }
        }
      }

    .more-info-container1 {
      margin-left: 35px;
      margin-right: 20px;

      a {
        margin-top: 15px;
        color: #2890FE;
        text-decoration: underline;
        display: block;
        font-size: 14px;

        &:first-child {
          margin-top: 20px;
        }
      }
    }

    .warning{
        margin: 0 20px 20px 20px;
        padding: 10px;
        background-color: #F5F5F5;
        border-radius: 10px;
        overflow: hidden;
        .warning-tag{
          float: left;
          width: 15px;
          p{
            line-height: 25px;
            color: #999999;
            text-align: center;
          }
        }
        .warning-content{
          margin-left: 15px;
          p{
            line-height: 22px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            letter-spacing: 1px;
          }
        }
      }

      .share-container{
        height: 70px;
        position: relative;
        margin-bottom: 50px;
        .share{
          height: 45px;
          line-height: 45px;
          width: 170px;
          background-color: #F5F9FF;
          border-radius: 10px;
          text-align: center;

          span{
            color: #2890FE;
            font-size: 14px;
          }
        }
      }
  }
}
.toast {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    line-height: 36px;
    height: 36px;
    width: 120px;
    text-align: center;
    background: black;
    opacity: 0.9;
    color: white;
    font-size: 12px;
    border-radius: 8px;
  }
</style>
